module.exports = __webpack_public_path__ + "static/media/icon_email.5e450671.svg";